import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

const AdminUsers = () => {
  const { user } = useContext(AuthContext);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/auth/users`,
          {
            headers: {
              Authorization: `Bearer ${user.token}`
            }
          }
        );

        const data = await res.json();

        setUsers(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    if (user?.token) {
      fetchUsers();
    }
  }, [user]);

  const makeAdmin = async (id) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/users/${id}/make-admin`,
        {
          method: 'PUT',
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        }
      );

      const data = await res.json();

      if (!res.ok) {
        alert(data.message || 'Failed to make admin');
        return;
      }

      alert('User promoted to admin successfully');

      setUsers((prevUsers) =>
        prevUsers.map((item) =>
          item._id === id
            ? { ...item, role: 'admin' }
            : item
        )
      );
    } catch (error) {
      console.error('Make admin error:', error);
      alert('Something went wrong');
    }
  };

  return (
    <div style={containerStyle}>
      <h2 style={headingStyle}>User Directory</h2>

      <div style={{ overflowX: 'auto' }}>
        <table style={tableStyle}>
          <thead>
            <tr style={rowStyle}>
              <th style={thStyle}>ID</th>
              <th style={thStyle}>NAME</th>
              <th style={thStyle}>EMAIL</th>
              <th style={thStyle}>ROLE</th>
              <th style={thStyle}>JOINED</th>
              <th style={thStyle}>ACTION</th>
            </tr>
          </thead>

          <tbody>
            {users.map((u) => (
              <tr key={u._id} style={rowStyle}>
                <td style={tdStyle}>
                  {u._id.substring(0, 8)}...
                </td>

                <td style={tdStyle}>
                  {u.name}
                </td>

                <td style={tdStyle}>
                  {u.email}
                </td>

                <td style={tdStyle}>
                  <span
                    style={{
                      background:
                        u.role === 'admin'
                          ? 'rgba(242,193,67,0.2)'
                          : 'rgba(16,185,129,0.2)',
                      color:
                        u.role === 'admin'
                          ? '#F2C143'
                          : '#10B981',
                      padding: '4px 8px',
                      borderRadius: '4px',
                      fontSize: '0.85rem',
                      fontWeight: 'bold'
                    }}
                  >
                    {u.role.toUpperCase()}
                  </span>
                </td>

                <td style={tdStyle}>
                  {new Date(u.createdAt).toLocaleDateString()}
                </td>

                <td style={tdStyle}>
                  {u.role === 'admin' ? (
                    <span
                      style={{
                        color: '#10B981',
                        fontWeight: 'bold'
                      }}
                    >
                      ADMIN
                    </span>
                  ) : (
                    <button
                      onClick={() => makeAdmin(u._id)}
                      style={buttonStyle}
                    >
                      Make Admin
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const containerStyle = {
  maxWidth: '1200px',
  margin: '40px auto',
  padding: '30px',
  background: '#0A123F',
  borderRadius: '12px',
  border: '1px solid rgba(242,193,67,0.12)',
  color: '#FFFFFF'
};

const headingStyle = {
  color: '#FCE475',
  marginBottom: '20px'
};

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse'
};

const rowStyle = {
  borderBottom: '1px solid rgba(255,255,255,0.1)'
};

const thStyle = {
  padding: '15px',
  textAlign: 'left',
  color: '#C7CBD9',
  fontSize: '0.9rem'
};

const tdStyle = {
  padding: '15px',
  textAlign: 'left'
};

const buttonStyle = {
  background: '#F2C143',
  color: '#06102F',
  border: 'none',
  padding: '8px 12px',
  borderRadius: '6px',
  cursor: 'pointer',
  fontWeight: '600'
};

export default AdminUsers;